import { handleCommonErrors, useQueryApi } from 'utils/api'

import type { CommonResponse } from 'typings/api'
import type { CLItem } from 'typings/microlearning'

export function useGetCLItem(id?: number, enabled: boolean = true) {
  return useQueryApi<CommonResponse<CLItem>>(
    `/microlearnings/contextualized-page/v1/${id}/detail`,
    {
      queryConfig: {
        enabled: enabled && !!id,
      },
      errorHandlerFn: (status, path, error) => {
        handleCommonErrors(status ?? 500, path, error)
      },
    }
  )
}
